import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { HttpCall, IHttpClient } from 'utils/http/httpClient.model';

export type GuideTourPersistencePayload = {
  completedSteps: string[];
};

export type GuidedTourPersistenceRequest = GuideTourPersistencePayload;

export function guidedTourConnector(http: IHttpClient) {
  return {
    saveCompletedStep(stepId: string) {
      return http
        .postRAW({
          url: `api/v1/user-guided-tour/step/${stepId}`,
        })
        .pipe(map(() => void 0));
    },
    loadCompletedSteps(): Observable<string[]> {
      return http
        .getJSON<GuideTourPersistencePayload>({
          url: 'api/v1/user-guided-tour',
        })
        .pipe(map((r: HttpCall<GuideTourPersistencePayload>) => r.payload.completedSteps));
    },
  };
}
